import SingleDatePicker from "../input-range-data";

interface SelectDateProps {
  id: string;
  label: string;
  value?: string | undefined | Date;
  onChange: (date: string | undefined | Date) => void;
}

export function SelectDate({ id, label, value, onChange }: SelectDateProps) {
  const handleDateChange = (date: Date | null) => {
    const formatted = date ? date.toISOString().split("T")[0] : undefined;
    onChange(formatted);
  };

  return (
    <div className="flex-1 flex flex-col gap-2">
      <SingleDatePicker
        id={id}
        label={label}
        date={value ? new Date(value + "T00:00:00") : undefined}
        onDateChange={(date) => handleDateChange(date || null)}
      />
    </div>
  );
}
